import type { BillingStatus } from '@/services/billingApi';

/**
 * Whether a pre-roll ad should play before content. Ads only ever target Limited
 * (recruitee, unpaid) users whose daily free plays are spent, and only when the
 * paywall is enforced AND an ad tag is configured. Everyone else (owned, comp,
 * admin, or limited-with-plays-left) watches without an ad.
 */
export function shouldShowPreroll(
  billing: BillingStatus | null,
  adTagConfigured: boolean,
): boolean {
  if (!adTagConfigured) return false;
  if (!billing || !billing.paywallEnabled) return false;
  if (billing.kind !== 'limited') return false;
  return billing.dailyMedia?.adRequired === true;
}
